"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEmptyRecipient = void 0;

var createEmptyRecipient = function createEmptyRecipient(email) {
  return {
    firstName: '',
    lastName: '',
    employment: '',
    country: undefined,
    email,
    phone: '',
    employmentPosition: ''
  };
};

exports.createEmptyRecipient = createEmptyRecipient;